import { useEffect, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/Ui/Button';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import ProfileDetailValidation from '../../yup/Profile/ProfileDetailValidation';
import { DetailProfileAction, GetProfileAction, ProfileDetailsAction } from '../../redux/Action/ProfileAction';
import { Config } from '../../config/Config';
import ApprovalPendingModel from '../../components/Model/ApprovalPendingModel';
import { GETAPI } from '../../api/Api';
import { ApiConstants } from '../../constants/ApiConstants';
import { LocalFormat, UTCFormat, saveToStorage } from '../../utils/Helper';
import { StorageConstants } from '../../constants/Constants';
import Spinner from '../../components/Spinner';

import Errormessages from '../../components/ErrorMessage/Errormessages';
import CommanForm from '../../components/FormController/Commanform';

import { ImageContainer } from '../../constants/ImagesConstants';
import { FormattedDate, FormattedMessage } from 'react-intl';
const { ProfileDetailBannerImage } = ImageContainer
import { useIntl } from 'react-intl';
import ProfileDetailsSubscriptionStep from './ProfileDetailsSubscriptionStep';

/** After profile form submit, show optional subscription step until user skips or submits (survives refresh). */
const PROFILE_SUBSCRIPTION_WIZARD_KEY = 'fely_complete_profile_subscription_wizard';

const ProfileDetails = () => {
    const intl = useIntl();
    const local_language = localStorage.getItem('lang')

    const dispatch = useDispatch<any>();
    const profileDetails = useSelector((state: any) => state.ProfileDetailState);
    const complete_profile_data = useSelector((state: any) => state.DetailProfileState);
    const profileData = useSelector((state: any) => state.GetProfileState);
    const navigate = useNavigate();

    const [showSubscriptionStep, setShowSubscriptionStep] = useState(() => {
        try {
            return sessionStorage.getItem(PROFILE_SUBSCRIPTION_WIZARD_KEY) === '1';
        } catch {
            return false;
        }
    });

    const finishProfileSubscriptionWizard = () => {
        try {
            sessionStorage.removeItem(PROFILE_SUBSCRIPTION_WIZARD_KEY);
        } catch (_) { /* ignore */ }
        window.location.href = Config?.BASE_URL + "/";
    };

    const [calendarError, setCalendarError] = useState("");


    const { register, watch, setValue, errors, handleSubmit } = CommanForm({
        validationSchema: ProfileDetailValidation, defaultValues: { ownerName: '', experience: '' }
    });

    const daysOfWeekAlbenia = {
        en: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        alb: ['E hënë', 'E martë', 'E mërkurë', 'E enjte', 'E premte', 'E shtunë', 'E diel']
    };
    const albanianToEnglishDaysMap: any = {
        'E hënë': 'Monday',
        'E martë': 'Tuesday',
        'E mërkurë': 'Wednesday',
        'E enjte': 'Thursday',
        'E premte': 'Friday',
        'E shtunë': 'Saturday',
        'E diel': 'Sunday'
    };


    const [calendar, setCalendar] = useState([
        { day: daysOfWeekAlbenia.alb[0], start_time: "", end_time: "", is_day_off: false, error: { start_time: "", end_time: "" } },
        { day: daysOfWeekAlbenia.alb[1], start_time: "", end_time: "", is_day_off: false, error: { start_time: "", end_time: "" } },
        { day: daysOfWeekAlbenia.alb[2], start_time: "", end_time: "", is_day_off: false, error: { start_time: "", end_time: "" } },
        { day: daysOfWeekAlbenia.alb[3], start_time: "", end_time: "", is_day_off: false, error: { start_time: "", end_time: "" } },
        { day: daysOfWeekAlbenia.alb[4], start_time: "", end_time: "", is_day_off: false, error: { start_time: "", end_time: "" } },
        { day: daysOfWeekAlbenia.alb[5], start_time: "", end_time: "", is_day_off: false, error: { start_time: "", end_time: "" } },
        { day: daysOfWeekAlbenia.alb[6], start_time: "", end_time: "", is_day_off: false, error: { start_time: "", end_time: "" } }
    ]);





    // Handle checkbox change
    const handleCheckboxChange = (index: any, start: any, end: any, error: any) => {
        const updatedCalendar = [...calendar];
        updatedCalendar[index].is_day_off = !updatedCalendar[index].is_day_off;

        if (!updatedCalendar[index].is_day_off) {
            updatedCalendar[index].start_time = "";
            updatedCalendar[index].end_time = "";
            updatedCalendar[index].error = { start_time: "", end_time: "" };
        }
        else {
            if (!updatedCalendar[index].start_time) {
                updatedCalendar[index].error.start_time = local_language == "alb" ? "Ju lutemi shkruani orën e fillimit." : "Please enter start time";
            }
            if (!updatedCalendar[index].end_time) {
                updatedCalendar[index].error.end_time = local_language == "alb" ? "Ju lutemi shkruani orën e përfundimit" : "Please enter end time";
            }
        }

        setCalendar(updatedCalendar);
    };


    // Handle input field change
    const handleInputFieldChange = (index: any, field: any, value: any) => {
        const updatedCalendar: any = [...calendar];
        updatedCalendar[index][field] = value;

        if (updatedCalendar[index].is_day_off) {
            if (field === "start_time" && value) {
                updatedCalendar[index].error.start_time = "";
            } else if (field === "end_time" && value) {
                updatedCalendar[index].error.end_time = "";
            }
        }

        if (!updatedCalendar[index].is_day_off) {
            if ((field === "start_time" && value) || (field === "end_time" && value)) {
                updatedCalendar[index].is_day_off = true;
            }
        }

        if (updatedCalendar[index].is_day_off) {
            if (field === "start_time" && !value) {
                updatedCalendar[index].error.start_time = local_language == "alb" ? "Ju lutemi shkruani orën e fillimit." : "Please enter start time";
            } else if (field === "end_time" && !value) {
                updatedCalendar[index].error.end_time = local_language == "alb" ? "Ju lutemi shkruani orën e përfundimit" : "Please enter end time";
            }
        }

        if (field === 'start_time' && updatedCalendar[index]['end_time'] && value >= updatedCalendar[index]['end_time']) {
            updatedCalendar[index].error.start_time = "Start time must be earlier than end time";
        } else if (field === 'end_time' && updatedCalendar[index]['start_time'] && value <= updatedCalendar[index]['start_time']) {
            updatedCalendar[index].error.end_time = "End time must be later than start time";
        } else {
            updatedCalendar[index].error.start_time = "";
            updatedCalendar[index].error.end_time = "";
        }

        if ((field === 'start_time' || field === 'end_time') && updatedCalendar[index]['start_time'] && updatedCalendar[index]['end_time']) {
            const startTime = moment(updatedCalendar[index]['start_time'], 'HH:mm');
            const endTime = moment(updatedCalendar[index]['end_time'], 'HH:mm');

            if (!startTime.isValid()) {
                updatedCalendar[index].error.start_time = local_language == "alb" ? "Ju lutemi shkruani orën e fillimit." : "Please select start time";
            } else if (!endTime.isValid()) {
                updatedCalendar[index].error.end_time = local_language == "alb" ? "Ju lutemi shkruani orën e përfundimit" : "Please select end time";
            } else {
                const duration = moment.duration(endTime.diff(startTime));
                if (duration.asHours() < 2) {
                    updatedCalendar[index].error.end_time = local_language == "alb" ? "Duhet të ketë të paktën 2 orë ndërmjet kohës së fillimit dhe përfundimit" : "There must be at least 2 hours between start and end times";
                } else {
                    updatedCalendar[index].error.end_time = "";
                }
            }
        }

        // Additional checks to ensure both times are provided
        if (field === 'start_time' && !updatedCalendar[index]['end_time']) {
            updatedCalendar[index].error.end_time = local_language == "alb" ? "Ju lutemi shkruani orën e përfundimit" : "Please enter end time";
        } else if (field === 'end_time' && !updatedCalendar[index]['start_time']) {
            updatedCalendar[index].error.start_time = local_language == "alb" ? "Ju lutemi shkruani orën e fillimit." : "Please enter start time";
        }

        setCalendar(updatedCalendar);
    };



    const handleToClickAll = () => {
        const commonTime = calendar.find(day => day.start_time && day.end_time);
        if (commonTime) {
            const { start_time, end_time } = commonTime;
            setCalendar(calendar.map(day => ({
                ...day,
                start_time,
                end_time,
                is_day_off: true,
                error: { start_time: "", end_time: "" }
            })));
        }
    };


    const validateCalendar = () => {
        const updatedCalendar = [...calendar];
        let hasError = false;
        updatedCalendar.forEach((day, index) => {
            // Only validate when the day is selected (is_day_off is false)
            if (day?.is_day_off == true) {
                if (!day.start_time) {
                    updatedCalendar[index].error.start_time = local_language == "alb" ? "Ju lutemi shkruani orën e fillimit." : "Please enter start time";
                    hasError = true;
                }
                if (!day.end_time) {
                    updatedCalendar[index].error.end_time = local_language == "alb" ? "Ju lutemi shkruani orën e përfundimit" : "Please enter end time";
                    hasError = true;
                }

                if (day.start_time && day.end_time) {
                    const startTime = moment(day.start_time, 'HH:mm');
                    const endTime = moment(day.end_time, 'HH:mm');

                    if (!startTime.isValid()) {
                        updatedCalendar[index].error.start_time = local_language == "alb" ? "Ju lutemi shkruani orën e fillimit." : "Please select start time";
                        hasError = true;
                    }
                    if (!endTime.isValid()) {
                        updatedCalendar[index].error.end_time = local_language == "alb" ? "Ju lutemi shkruani orën e përfundimit" : "Please select end time";
                        hasError = true;
                    }
                    if (startTime.isValid() && endTime.isValid()) {
                        const duration = moment.duration(endTime.diff(startTime));
                        if (duration.asHours() < 2) {
                            updatedCalendar[index].error.end_time = local_language == "alb" ? "Duhet të ketë të paktën 2 orë ndërmjet kohës së fillimit dhe përfundimit" : "There must be at least 2 hours between start and end times";
                            hasError = true;
                        }
                    }
                }

                if (day.start_time && day.end_time && day.start_time >= day.end_time) {
                    updatedCalendar[index].error.start_time = local_language == "alb" ? "Koha e fillimit duhet të jetë më e hershme se koha e përfundimit" : "Start time must be earlier than end time";
                    hasError = true;
                }
                if (day.end_time && day.start_time && day.end_time <= day.start_time) {
                    updatedCalendar[index].error.end_time = local_language == "alb" ? "Koha e përfundimit duhet të jetë më vonë se ora e fillimit" : "End time must be later than start time";
                    hasError = true;
                }

                if (!day.start_time && day.end_time) {
                    updatedCalendar[index].error.start_time = local_language == "alb" ? "Ju lutemi shkruani orën e fillimit." : "Please enter start time";
                    hasError = true;
                }
                if (!day.end_time && day.start_time) {
                    updatedCalendar[index].error.end_time = local_language == "alb" ? "Ju lutemi shkruani orën e përfundimit" : "Please enter end time";
                    hasError = true;
                }
            }
        });

        setCalendar(updatedCalendar);
        return !hasError;
    };





    const [data, setData] = useState(null);

    useEffect(() => {
        const formatTimes = () => {
            const formattedCalendar: any = calendar.map(day => {
                return {
                    ...day,
                    day: albanianToEnglishDaysMap[day.day],
                    start_time: day.start_time ? UTCFormat(day.start_time) : "",
                    end_time: day.end_time ? UTCFormat(day.end_time) : ""
                    // start_time: day.start_time ? moment(day.start_time).format('HH:mm') : "",
                    // end_time: day.end_time ? moment(day.end_time).format('HH:mm') : ""
                };
            });
            setData(formattedCalendar);
        };
        formatTimes()

    }, [calendar])


    const onSubmit: any = (e: any) => {
        // e.preventDefault()

        if (!validateCalendar()) {
            return
        }

        const isValid = calendar.some(day => day.is_day_off && day.start_time && day.end_time);
        if (!isValid) {
            // setCalendarError("Please select at least one day ");
            setCalendarError(local_language == "alb" ? "Ju lutemi zgjidhni të paktën një orë pune të sallonit" : "Please select at least one operational hours of salon.");
            // setCalendarError(local_language == "alb" ? "Ju lutemi zgjidhni të paktën një orë pune të sallonit." : "Please select at least one operational hours of salon.");

            return;
        }

        const isError = calendar.some(day => day?.error?.start_time != "" || day?.error?.end_time != "");
        if (isError) {
            return;
        }

        const payload: any = {
            owner_name: e?.ownerName,
            owner_experience: e?.experience,
            opt_days: data,
            // avg_scale: 1
        }



        // if (approvelPendingRef.current) {
        //     approvelPendingRef.current.click()
        // }

        dispatch(ProfileDetailsAction(payload))

    };



    useEffect(() => {
        if (!profileDetails?.status) return;
        saveToStorage({ key: StorageConstants?.APPROVAL_STATUS, value: profileData?.data?.data?.is_approved })
        try {
            sessionStorage.setItem(PROFILE_SUBSCRIPTION_WIZARD_KEY, '1');
        } catch (_) { /* ignore */ }
        dispatch(ProfileDetailsAction('RESET' as any));
        dispatch(GetProfileAction({}));
        (async () => {
            const profile: any = await GETAPI(ApiConstants.GetProfile, {}, false);
            if (profile?.status && profile?.data) {
                const userRow = profile.data?.data ?? profile.data;
                if (userRow && typeof userRow === 'object') {
                    saveToStorage({ key: StorageConstants.USER_DETAIL, value: userRow });
                    Config.USER_DETAILS = userRow;
                }
            }
            setShowSubscriptionStep(true);
        })();
    }, [profileDetails])




    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (profileData?.loading) return;
        const u = profileData?.data?.data;
        if (!u) return;
        try {
            if (sessionStorage.getItem(PROFILE_SUBSCRIPTION_WIZARD_KEY) === '1' && Number(u.is_profile_setup) !== 2) {
                sessionStorage.removeItem(PROFILE_SUBSCRIPTION_WIZARD_KEY);
                setShowSubscriptionStep(false);
            }
        } catch (_) { /* ignore */ }
        if (u.is_profile_setup == 2 && Config?.USER_DETAILS?.role_id == 1) {
            let inSubscriptionWizard = false;
            try {
                inSubscriptionWizard = sessionStorage.getItem(PROFILE_SUBSCRIPTION_WIZARD_KEY) === '1';
            } catch (_) { /* ignore */ }
            if (inSubscriptionWizard) {
                setShowSubscriptionStep(true);
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            navigate("/");
        }
    }, [profileData])




    if (isLoading) {
        return <>
        </>
    }

    /* **************************** Detail profile data start **************************** */
    useEffect(() => {
        dispatch(DetailProfileAction({ type: 2 }))
    }, [])

    useEffect(() => {
        if (complete_profile_data?.status) {
            setValue("ownerName", complete_profile_data?.data?.data?.owner_name ? complete_profile_data?.data?.data?.owner_name : "");
            setValue("experience", complete_profile_data?.data?.data?.owner_experience ? complete_profile_data?.data?.data?.owner_experience : "");
            const optDays = complete_profile_data?.data?.data?.opt_days ? complete_profile_data?.data?.data?.opt_days : null;
            if (optDays) {
                const updatedCalendar: any = calendar.map((day) => {
                    // const matchingProfileDay = complete_profile_data?.data?.data?.opt_days?.find((profileDay: any, is_day_off: any) => profileDay.day === day.day);
                    const matchingProfileDay = complete_profile_data?.data?.data?.opt_days?.find((profileDay: any, is_day_off: any) => albanianToEnglishDaysMap[day.day] == profileDay.day)

                    // const matchingProfileDay = complete_profile_data?.data?.data?.opt_days?.find((profileDay: any, is_day_off: any) => profileDay.day === day.day);
                    if (matchingProfileDay) {
                        // let local_start_time = matchingProfileDay.start_time;
                        // let local_end_time = matchingProfileDay.end_time;
                        let local_start_time = matchingProfileDay.start_time != "00:00:00" && matchingProfileDay.start_time;
                        let local_end_time = matchingProfileDay.end_time != "00:00:00" && matchingProfileDay.end_time;

                        const originalStartTime = local_start_time.length > 0 ? local_start_time : '';
                        const originalEndTime = local_end_time.length > 0 ? local_end_time : '';

                        // Parse start_time
                        const targetStartDate = moment().toDate();
                        const [startHours, startMinutes, startSeconds] = originalStartTime.split(':');
                        targetStartDate.setHours(Number(startHours));
                        targetStartDate.setMinutes(Number(startMinutes));
                        targetStartDate.setSeconds(Number(startSeconds));
                        const formattedStartDate = targetStartDate.toString();

                        // Parse end_time
                        const targetEndDate = moment().toDate();
                        const [endHours, endMinutes, endSeconds] = originalEndTime.split(':');
                        targetEndDate.setHours(Number(endHours));
                        targetEndDate.setMinutes(Number(endMinutes));
                        targetEndDate.setSeconds(Number(endSeconds));
                        const formattedEndDate = targetEndDate.toString();

                        // Check validity of formatted dates
                        if (formattedStartDate?.length > 0 && formattedStartDate !== "Invalid Date" &&
                            formattedEndDate?.length > 0 && formattedEndDate !== "Invalid Date") {

                            // return {
                            //     ...day,
                            //     is_day_off: matchingProfileDay?.is_day_off ? true : false,
                            //     start_time: formattedStartDate ? moment(formattedStartDate).toDate() : '',
                            //     end_time: formattedEndDate ? moment(formattedEndDate).toDate() : '',
                            // };
                            const startTime = LocalFormat(formattedStartDate)
                            const endTime = LocalFormat(formattedEndDate)
                            return {
                                ...day,
                                is_day_off: matchingProfileDay?.is_day_off ? true : false,
                                start_time: formattedStartDate ? moment(startTime).toDate() : '',
                                end_time: formattedEndDate ? moment(endTime).toDate() : '',
                            };

                        }
                    }

                    return day;
                });
                setCalendar(updatedCalendar);
            }



        }

    }, [complete_profile_data]);
    /* **************************** Detail profile data end **************************** */

    const [isLoadingData, setIsLoadingData] = useState(true);


    useEffect(() => {
        setIsLoadingData(false);
    }, []);

    if (isLoadingData) {
        return <Spinner />;
    }


    return (
        <>
            {profileData?.loading ? <Spinner /> : ""}

            <section className='innerBanner'>
                <img alt='banner' src={ProfileDetailBannerImage} />
                <div className='BannerText container'>
                    <div className='row'>
                        <div className='col-lg-10 mx-auto'>
                            <h1>
                                {showSubscriptionStep ? (
                                    <FormattedMessage
                                        id="profile_subscription_banner_title"
                                        defaultMessage="Subscription request"
                                    />
                                ) : (
                                    <FormattedMessage id="complete_profile" />
                                )}
                            </h1>
                            <p>
                                {showSubscriptionStep ? (
                                    <FormattedMessage
                                        id="profile_subscription_banner_subtitle"
                                        defaultMessage="Submit your payment details for admin review, or skip and complete this later from your account."
                                    />
                                ) : (
                                    <FormattedMessage id="profile_message" />
                                )}
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className='container'>
                    {showSubscriptionStep ? (
                        <ProfileDetailsSubscriptionStep
                            onSkip={finishProfileSubscriptionWizard}
                            onSubmitSuccess={finishProfileSubscriptionWizard}
                        />
                    ) : (
                    <div className='profileDetailsBox'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='profileINfo'>
                                <h6><FormattedMessage id="profile_details" /></h6>
                                <div className='row gy-4'>
                                    <div className="col-md-6 normalINput">
                                        <label className="form-label"><FormattedMessage id="owner_name" />*</label>
                                        {/* <input type="text" className="form-control" placeholder="Enter Owner Name"
                                            {...register("ownerName")}
                                            value={watch("ownerName")}
                                            
                                        /> */}
                                        <input type="text" className="form-control" placeholder={intl.formatMessage({ id: 'owner_name' })} {...register('ownerName')}

                                            onInput={(e: any) => {
                                                const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                setValue("ownerName", value);
                                            }}
                                        />
                                        <Errormessages errors={errors} name="ownerName" />

                                    </div>
                                    <div className="col-md-6 normalINput">
                                        <label className="form-label"><FormattedMessage id="owner_experience_years" />*</label>
                                        <input type="text" className="form-control" placeholder={intl.formatMessage({ id: 'enter_owner_experience' })}
                                            {...register("experience")}
                                            value={watch("experience")}
                                        />
                                        <Errormessages errors={errors} name="experience" />

                                    </div>
                                    {/* <div className="col-lg-12 col-xl-6">
                                        <label className="form-label">Average Scale of Salon</label>
                                        <div className='inputSpan'>
                                            <input placeholder='€ - €€'
                                                {...register("inputs.input1")}
                                                value={watch("inputs.input1")}
                                            />
                                            <ErrorMessage
                                                errors={errors}
                                                name="errors.input1"
                                                render={({ message }) => <p className='text-danger'>{message}</p>}
                                            />

                                            <input placeholder='€ - €€'
                                                {...register("inputs.input2")}

                                                value={watch("inputs.input2")}
                                            />
                                            <ErrorMessage
                                                errors={errors}
                                                name="errors.input2"
                                                render={({ message }) => <p className='text-danger'>{message}</p>}
                                            />
                                            <input placeholder='€ - €€'
                                                {...register("inputs.input3")}

                                                value={watch("inputs.input3")}
                                            />
                                            <ErrorMessage
                                                errors={errors}
                                                name="errors.input3"
                                                render={({ message }) => <p className='text-danger'>{message}</p>}
                                            />
                                         
                                          

                                        </div>
                                        <div className='imputsmall'>
                                            <div>
                                                <input className='form-control' placeholder='€ - €€'
                                                    {...register("inputs.input1")}
                                                    value={watch("inputs.input1")}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="inputs.input1"
                                                    render={({ message }) => <p className='text-danger'>{message}</p>}
                                                />
                                            </div>

                                            <div>
                                                <input className='form-control' placeholder='€ - €€'
                                                    {...register("inputs.input2")}
                                                    value={watch("inputs.input2")}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="inputs.input2"
                                                    render={({ message }) => <p className='text-danger'>{message}</p>}
                                                />
                                            </div>

                                            <div>
                                                <input className='form-control' placeholder='€ - €€'
                                                    {...register("inputs.input3")}
                                                    value={watch("inputs.input3")}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="inputs.input3"
                                                    render={({ message }) => <p className='text-danger'>{message}</p>}
                                                />
                                            </div>

                                        </div>

                                    </div> */}
                                </div>
                            </div>
                            <div className='WOrkDay table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th><FormattedMessage id="operational_days_of_salon" />*</th>
                                            <th><FormattedMessage id="operational_hours_of_salon" />*</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {calendar.map((item: any, index: any) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="form-check ps-0">
                                                            <input className="form-check-input" id={`flexCheckDefault${index}`} type="checkbox"
                                                                checked={item.is_day_off}
                                                                onChange={(e: any) => {
                                                                    handleCheckboxChange(index, "start_time", "end_time", item.error)
                                                                    setCalendarError("")
                                                                }}
                                                            />
                                                            <label className="form-check-label" htmlFor={`flexCheckDefault${index}`}>
                                                                <FormattedMessage id={albanianToEnglishDaysMap[item.day] || item.day} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='row normalINput'>
                                                            <div className='col-6'>
                                                                <DatePicker
                                                                    className="form-control"
                                                                    selected={item.start_time ? item.start_time : null}
                                                                    onChange={(date: any) => {
                                                                        handleInputFieldChange(index, 'start_time', date)
                                                                        setCalendarError("")
                                                                    }}
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    timeIntervals={5}
                                                                    timeCaption="Time"
                                                                    // dateFormat="HH:mm"

                                                                    dateFormat="HH:mm"
                                                                    timeFormat="HH:mm"
                                                                    placeholderText="00:00"
                                                                />

                                                                <p className='text-danger'>{item.error.start_time}</p>
                                                            </div>
                                                            <div className='col-6'>
                                                                <DatePicker
                                                                    selected={item.end_time ? item.end_time : null}
                                                                    className="form-control"
                                                                    onChange={(time: any) => {
                                                                        handleInputFieldChange(index, 'end_time', time)
                                                                        setCalendarError("")
                                                                    }}
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    timeIntervals={5}
                                                                    timeCaption="Time"
                                                                    dateFormat="HH:mm"
                                                                    timeFormat="HH:mm"
                                                                    placeholderText="00:00"

                                                                />

                                                                <p className='text-danger'>{item.error.end_time}</p>
                                                            </div>


                                                        </div>


                                                    </td>
                                                    {index === 0 && <td><button type="button" className='applyAll' onClick={handleToClickAll}><FormattedMessage id="apply_for_all" /></button></td>}
                                                </tr>
                                            )
                                        }

                                        )}
                                        {calendarError && <tr><td className='text-danger'>{calendarError}</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                            <div className='PRODetails_bottom mb-80'>
                                {/* <Button className='btn btn-fill' text="submit" isLoading={profileDetails?.loading} onClick={handleSubmit} /> */}
                                {/* <button type="button" style={{ display: 'none' }} data-bs-toggle="modal" data-bs-target="#approval-box" className='btn btn-fill' ref={approvelPendingRef}>Sign Up</button> */}

                                <Button className='btn btn-fill' text={<FormattedMessage id="submit_and_subscription" defaultMessage="Submit & subscription" /> as any} isLoading={profileDetails?.loading} type="submit" />
                                {/* <button type="submit" className="btn btn-fill">Submit</button> */}
                                {/* <button type="submit" className="btn btn-fill">Submit</button> */}
                            </div>
                        </form>
                    </div>
                    )}
                </div>
                {/* <>
                    <Link className='approval-box' to='#approval-box' data-bs-toggle="modal">Forgot Password?</Link>

                </> */}
            </section >
            <ApprovalPendingModel />
        </>
    );
};

export default ProfileDetails;


